<template>
  <div class="container">
    <!-- 1级标题 -->
    <template v-for="row of ebooks" :key="row.id">
      <div class="data">
        <a-typography-title :level="5">{{ row.parent.name }}</a-typography-title>
        <!-- 2级标题 -->
        <div v-for="child of row.children" :key="child.category.id" class="list">
          <h4 :level="6" style="color: #1E90FF;">{{ child.category.name }}</h4>
          <!-- 展示图书列表 child.ebooks -->
          <the-ebooks-card :data="child.ebooks"></the-ebooks-card>
        </div>
      </div>
      <!-- 分割线 -->
      <a-divider />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, defineProps, ref, onMounted, watch } from 'vue'
import axios from 'axios';
import { message } from "ant-design-vue";
import { anyType } from 'ant-design-vue/es/_util/type';
import TheEbooksCard from './the-ebooks-card.vue';

export default defineComponent({
  name: 'TheEbooks',
  components: {
    TheEbooksCard
  },
  props: {
    id: {
      type: Number,     // 父组件传递给子组件的数据类型
      required: false,  // 是否必填
      default: -1        // 默认值， 如果传入的是 Object，则要 default: ()=>({}) 参数为函数
    }
  },

  setup(props) {

    let ebooks = ref([{
      id: undefined,
      parent: {
        name: undefined
      },
      children: [
        {
          category: {
            id: undefined,
            name: undefined,
          },
          ebooks: []
        }
      ]
    }]);


    // 监听id变化
    watch(() => props.id, async (newId, oldId) => {
      console.log('watch', newId, oldId)
      handleQueryEbooks(newId);
      //过滤数据
      //console.log(' ======= ' + ebooks.value + " =======")
      // console.log(' ======= ' + ebooks.value.length + " =======")
      // if (ebooks.value.length > 0) {
      //   console.log(' ======= ' + ebooks.value[0].parent.name + " =======")
      // }

    })

    // 查询所有图书
    const handleQueryEbooks = (id: any) => {
      let url = "/category/ebooks"
      // 请求某个一级目录的所有图书
      if (id != 0) {
        //http://localhost:8080/wiki-biz/category/ebooks?id=200
        url = url + '?id=' + id
      }
      console.log(' ======= ' + url + " =======")
      axios.get(url).then((response) => {
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          console.log("图书列表：", result.data);
          ebooks.value = result.data;
        } else {
          message.error(result.message);
        }
      });
    };

    onMounted(() => {
      console.log('id -------' + props.id + '----------')

      if (props.id != -1) {
        handleQueryEbooks(props.id);
      }


    });

    return {
      ebooks,
      handleQueryEbooks,

    }
  }
});
</script>
<style scoped>
.container {
  /* background: #F2F4F6; */
  padding: 10px;
}

.data {
  margin-bottom: 30px;
  margin-top: 0px;
}

.list {
  /* background: #FFFFFF; */
  margin-bottom: 1px;
  margin-left: 20px;
  margin-right: 20px;
  padding: 20px;
}

</style>
